// translation.js
(function attachGlobalInit() {
  // Called by ?cb=googleTranslateElementInit after the script loads
  window.googleTranslateElementInit = function () {
    try {
      const c = document.cookie.split('; ').find(x => x.startsWith('googtrans='));
      const lang = c ? c.split('=')[1].split('/')[2] : 'en';
      if (window.google?.translate?.TranslateElement && !window.__gtInited) {
        new window.google.translate.TranslateElement(
          { pageLanguage: 'en', includedLanguages: 'en,es', autoDisplay: false },
          'google_translate_element'
        );
        window.__gtInited = true;

        // If cookie says non-EN, immediately switch the hidden combo
        if (lang && lang !== 'en') forceCombo(lang);
      }
    } catch (e) { /* noop */ }
  };
})();

function forceCombo(lang) {
  // Google injects a <select.goog-te-combo> (hidden by your CSS). We can still drive it.
  const combo = document.querySelector('select.goog-te-combo');
  if (combo) {
    combo.value = lang;
    combo.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  return false;
}

export function deleteGoogleTranslateCookies() {
  const host = window.location.hostname;
  const parts = host.split('.');
  const domains = new Set([host, '.' + host, null]);
  for (let i = 0; i < parts.length - 1; i++) {
    const parent = parts.slice(i).join('.');
    domains.add(parent);
    domains.add('.' + parent);
  }
  const base = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
  domains.forEach(d => { document.cookie = d ? `${base} domain=${d};` : base; });
}

export function applyLanguage(lang) {
  const ready = !!window.google?.translate?.TranslateElement;

  if (lang === 'en') {
    // Clear translation completely and tell the widget to switch back (no reload)
    deleteGoogleTranslateCookies();
    document.cookie = `googtrans=/auto/en; path=/; SameSite=Lax`;
    document.documentElement.classList.add('notranslate');
    document.documentElement.classList.remove('translated-ltr', 'translated-rtl');

    if (ready) {
      // If the widget exists, force its internal select to 'en'
      if (!forceCombo('en')) {
        // Wait briefly for combo to appear, then switch
        const t0 = Date.now();
        const iv = setInterval(() => {
          if (forceCombo('en') || Date.now() - t0 > 1500) clearInterval(iv);
        }, 100);
      }
    }
    return;
  }

  // Non-EN: set cookie and ensure widget exists, then flip combo to target lang
  document.documentElement.classList.remove('notranslate');
  deleteGoogleTranslateCookies();
  const value = `/auto/${lang}`;
  document.cookie = `googtrans=${value}; path=/; SameSite=Lax`;
  // document.cookie = `googtrans=${value}; path=/; domain=${window.location.hostname};`;

  if (ready) {
    if (!window.__gtInited) {
      new window.google.translate.TranslateElement(
        { pageLanguage: 'en', includedLanguages: 'en,es', autoDisplay: false },
        'google_translate_element'
      );
      window.__gtInited = true;
    }
    if (!forceCombo(lang)) {
      const t0 = Date.now();
      const iv = setInterval(() => {
        if (forceCombo(lang) || Date.now() - t0 > 1500) clearInterval(iv);
      }, 100);
    }
  } else {
    // Script not ready yet; wait for it rather than reloading
    const t0 = Date.now();
    const iv = setInterval(() => {
      if (window.google?.translate?.TranslateElement) {
        clearInterval(iv);
        applyLanguage(lang); // retry once GT is ready
      } else if (Date.now() - t0 > 2000) {
        clearInterval(iv);
      }
    }, 100);
  }
}
